import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Binoculars"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6V3.75C21 3.33579 20.6642 3 20.25 3H15.75C15.3358 3 15 3.33579 15 3.75V6C14.1716 6 13.5 6.67157 13.5 7.5V9H10.5V7.5C10.5 6.67157 9.82843 6 9 6V3.75C9 3.33579 8.66421 3 8.25 3H3.75C3.33579 3 3 3.33579 3 3.75V6C2.17157 6 1.5 6.67157 1.5 7.5V16.5C1.50322 17.0327 1.78868 17.5237 2.25 17.79V20.25C2.25 20.6642 2.58579 21 3 21H9C9.41421 21 9.75 20.6642 9.75 20.25V17.79C10.2113 17.5237 10.4968 17.0327 10.5 16.5V15H13.5V16.5C13.5032 17.0327 13.7887 17.5237 14.25 17.79V20.25C14.25 20.6642 14.5858 21 15 21H21C21.4142 21 21.75 20.6642 21.75 20.25V17.79C22.2113 17.5237 22.4968 17.0327 22.5 16.5V7.5C22.5 6.67157 21.8284 6 21 6ZM8.25 19.5H3.75V18H8.25V19.5ZM9 16.5H3V7.5H4.5V4.5H7.5V7.5H9V16.5ZM10.5 13.5V10.5H13.5V13.5H10.5ZM20.25 19.5H15.75V18H20.25V19.5ZM21 16.5H15V7.5H16.5V4.5H19.5V7.5H21V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Binoculars.vue"]]);
